/*
  Samtykkerutens tekst.

  Rutan är Shopifys inbyggda banner. Den injiceras i efterhand och dess text
  kommer från Shopifys eget script, inte från temat eller våra språkfiler —
  den går alltså inte att ändra i Liquid. Det här skriptet väntar in rutan och
  skriver om rubriken, stycket och avslå-knappen när den dykt upp.

  Orden hämtas ur nb.json via data-attribut på skripttaggen (theme.liquid), så
  butikens text bor på ett ställe och går genom språkgranskningen som allt
  annat. Formen och grepet är hämtade från Cazeléas tema.

  Länken till personvernerklæringen behålls som den är. Den är hela poängen
  med stycket, och den ska fortsätta peka på den policy där Shopify och övriga
  databehandlere namnges.
*/
(function () {
  var tag = document.querySelector('script[data-iv-consent-body]');
  if (!tag) return;

  var TITTEL = tag.getAttribute('data-iv-consent-title') || '';
  var TEKST = tag.getAttribute('data-iv-consent-body') || '';
  var AVSLA = tag.getAttribute('data-iv-consent-decline') || '';
  var GODTA = tag.getAttribute('data-iv-consent-accept') || '';
  var INNSTILLINGER = tag.getAttribute('data-iv-consent-prefs') || '';

  function skrivOm(banner) {
    var stykke = banner.querySelector('p');
    if (!stykke || stykke.dataset.ivOmskrevet) return false;

    /* Länken finns redan i stycket och ska stå kvar — bara flyttas till sin
       plats i vår mening. Platsen märks ut med %link% i språkfilen, så hela
       den synliga raden bor i EN nyckel och kan granskas som en mening.
       Utan platsmarkören hamnade länken sist och läste som ett löst ord:
       «Du velger selv hva du godtar. personvernerklæringen». */
    if (TEKST) {
      var lenke = stykke.querySelector('a');
      var delar = TEKST.split('%link%');
      stykke.textContent = '';
      stykke.appendChild(document.createTextNode(delar[0]));
      if (lenke) {
        stykke.appendChild(lenke);
        stykke.appendChild(document.createTextNode(delar.length > 1 ? delar[1] : ''));
      } else if (delar.length > 1) {
        /* Ingen länk i Shopifys ruta: sy ihop meningen utan den, och lämna
           inget dinglande «Les mer i .» efter sig. */
        stykke.textContent = delar[0].replace(/\s*(Les mer i|Read more in our)\s*$/, '');
      }
    }

    var tittel = banner.querySelector('#shopify-pc__banner__body-title');
    if (tittel && TITTEL) tittel.textContent = TITTEL;

    /* Alla tre knapparna skrivs om. Shopifys norska blandar former: «Avslå»
       och «Administrer preferanser» i imperativ, men «Akseptere» i infinitiv
       — den läser som en ordbokspost bredvid de andra. Norska knappar står i
       imperativ, och «Godta» rimmar dessutom med brödtextens «hva du godtar».
       «Preferanser» är dessutom anglicism där «innstillinger» är det norska. */
    var avsla = banner.querySelector('#shopify-pc__banner__btn-decline');
    if (avsla && AVSLA) avsla.textContent = AVSLA;

    var godta = banner.querySelector('#shopify-pc__banner__btn-accept');
    if (godta && GODTA) godta.textContent = GODTA;

    var innstillinger = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (innstillinger && INNSTILLINGER) innstillinger.textContent = INNSTILLINGER;

    stykke.dataset.ivOmskrevet = '1';
    return true;
  }

  function let_() {
    var banner = document.getElementById('shopify-pc__banner');
    return banner ? skrivOm(banner) : false;
  }

  if (let_()) return;

  /* Bannern kan dyka upp långt efter DOMContentLoaded. Vi tittar tills den
     kommer, och slutar titta när den gjort det eller efter 60 sekunder —
     annars ligger en observatör kvar och lyssnar på varje DOM-ändring resten
     av besöket. Cazeléa har 15 s; det räcker i praktiken men inte alltid på
     en trög uppkoppling, och en ruta som hinner fram efter tidsgränsen står
     kvar med Shopifys egen text. */
  var observator = new MutationObserver(function () {
    if (let_()) stopp();
  });

  function stopp() {
    observator.disconnect();
    clearTimeout(tidsgrense);
  }

  observator.observe(document.body, { childList: true, subtree: true });
  var tidsgrense = setTimeout(stopp, 60000);
})();

/*
  Mobilen (Daris 11 okt): rutan står mitt på skärmen över en mörk slöja, så
  att besökaren väljer innan sidan går att läsa. Godkänn och «Endast
  nödvändiga» är lika stora; slöjan tvingar fram ett val, inte ett ja.
  Slöjan följer rutan: den finns bara medan Shopifys ruta syns, och tas bort
  när ett val gjorts (visitorConsentCollected) eller rutan döljs.
*/
(function () {
  var mobil = window.matchMedia('(max-width: 749px)');
  var sloja = null, banner = null, klar = false;

  function syns(b) {
    return !!b && b.isConnected && getComputedStyle(b).display !== 'none' && b.getClientRects().length > 0;
  }

  function synka() {
    var visa = !klar && mobil.matches && syns(banner);
    if (visa && !sloja) {
      sloja = document.createElement('div');
      sloja.id = 'noelva-kaksloja';
      sloja.setAttribute('aria-hidden', 'true');
      document.body.appendChild(sloja);
      document.documentElement.classList.add('noelva-kak-oppen');
      banner.setAttribute('aria-modal', 'true');
    } else if (!visa && sloja) {
      sloja.remove();
      sloja = null;
      document.documentElement.classList.remove('noelva-kak-oppen');
      if (banner) banner.setAttribute('aria-modal', 'false');
    }
  }

  function hitta() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    banner = b;
    new MutationObserver(synka).observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    synka();
    return true;
  }

  document.addEventListener('visitorConsentCollected', function () {
    klar = true;
    synka();
  });
  if (mobil.addEventListener) mobil.addEventListener('change', synka);

  if (hitta()) return;
  var leta = new MutationObserver(function () {
    if (hitta()) { leta.disconnect(); clearTimeout(slut); }
  });
  leta.observe(document.body, { childList: true, subtree: true });
  var slut = setTimeout(function () { leta.disconnect(); }, 60000);
})();
